export const getArgsByGetParams = ()=> {
    const search = decodeURI(location.search)

        if( !search )
            return

    /** checks if there is a relevant get parameters */
    const argsFromURL = search.split('?')[1].split('&')
    for(let i = 0 ; i < argsFromURL.length; i++) {
        argsFromURL[i] = argsFromURL[i].split('=')[0]
    }
    const argsToLower =  argsFromURL.map( arg => arg.toLowerCase() )

    if(!(
        argsToLower.includes('city') ||
        argsToLower.includes('coo') ||
        argsToLower.includes('seed') ||
        argsToLower.includes('text') ||
        argsToLower.includes('act') ||
        argsToLower.includes('accH') ||
        argsToLower.includes('accO') ||
        argsToLower.includes('accD') ||
        argsToLower.includes('year') ||
        argsToLower.includes('area') 
    )) {
       return null
    }

    /** same request like returnArgsFunc() */

    const args = {
        City: '',
        Coo: '',
        Seed: '',
        Text: '',
        Act: '',
        accH: '0',
        accO: '0',
        accD: '0',
        Year: 1,
        Area: '',
        // _search: false,
        // nd: 1547731836326,
        // rows: 15,
        // page: 1,
        // sidx: 'Name',
        // sord: 'desc',

    }


    // build array of objects { name: 'Name', value: 'value } with uppercase for the first name string 
    //const searchArr = search.split('?')[1].split('&').map( el => ({ name: el.split('=')[0].charAt(0).toUpperCase() + el.split('=')[0].slice(1), value: el.split('=')[1] }) )
    const searchArr = search.split('?')[1].split('&').map( el => ({ name: el.split('=')[0], value: el.split('=')[1] }) )

    searchArr.forEach( element => {
        if( element.name in args ) {

            if( element.name !== 'Act' ) {
                args[element.name] = element.value
            } else {
                args[element.name] += `${element.value},`
            }

        }
    })

    if( args['Act'][args['Act'].length -1] === ',' )
        args['Act'] = args['Act'].slice(0, -1);

    return args
    
}